function create(type, filterTranslator) {
  return {
    id: `custom.${type}.Equals.ComparatorFilterConverter`,
    type: `${type}.Equals`,
    convert: (cmp, attribute) => {
      if (cmp.value1 == null) {
        return null;
      }
      return {
        type: 'logical',
        operator: 'or',
        conditions: cmp.value1?.reduce((prev, curr) => {
          if (filterTranslator[curr]) {
            prev.push(filterTranslator[curr]());
          }
          return prev;
        }, [])
      };
    }
  };
}
export default {
  create
};